import { Message } from "@/reducers/messagesSlice"
import { GroupedFile } from "@/components/ui/message"
import { getDownloadFileName } from "@/components/message/utils/getDownloadFileName"

export function useGroupedFiles(
  messages: (Message | undefined)[],
  fileSenderName: string,
): GroupedFile[] {
  return messages
    .filter((m): m is Message => m !== undefined)
    .map((m, index) => ({
      id: m.id,
      filename: getDownloadFileName(m, fileSenderName, index)!,
      src: m.url || m.body,
      thumbnail: m.thumbnail,
      pdf: Boolean(m.url?.toLowerCase().endsWith(".pdf")),
      message: m,
    }))
}
